const ALLOWED_INPUT_TYPES = ['date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week'];

export { ALLOWED_INPUT_TYPES };
